import version from '@/VERSION?raw';
import { datadogRum } from '@datadog/browser-rum';

if (
  import.meta.env.VITE_DATADOG_APPLICATION_ID &&
  import.meta.env.VITE_DATADOG_CLIENT_TOKEN &&
  import.meta.env.VITE_DATADOG_SERVICE &&
  import.meta.env.VITE_DATADOG_ENV
) {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: import.meta.env.VITE_DATADOG_SERVICE,
    env: import.meta.env.VITE_DATADOG_ENV,
    version: version.trim(),
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [
      /http:\/\/localhost:.*/,
      'https://api.packmatic.io',
      'https://api-staging.packmatic.io',
    ],
    traceSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
}

// Note: Frontend errors in datadog are currently duplicated
// (once from error source "console" and once from error source
// "source"). This is happens because react error boundary calls
// console.error() on every error it catches. Because we log any
// error that is either thrown or printed to console this means we
// get the same error twice.
// See this issue: https://github.com/facebook/react/issues/15069
// Which also has a workaround in the end (swallow error in onCaughtError)
// but we need React 19 for that.
export const logToDatadog = (
  error: Error,
  level: 'info' | 'warning' | 'error' | 'debug' = 'error',
) => {
  if (datadogRum) {
    datadogRum.addError(error, { level });
  }
};

export const recordActionToDatadog = (actionName: string, context: Record<string, string>) => {
  if (datadogRum) {
    datadogRum.addAction(actionName, { context });
  }
};
